let audioController = {
  playing: false,
  // TTS
  playingType: null,
  text: null,
  array: [],
  // Voice Recorder
  mediaRecorder: null,
  recording: false,
  audioChunks: [],
  player: null,

  // TTS
  ttsLoadVoices() {
    return new Promise(
      function (resolve) {
        let synth = window.speechSynthesis;
        let id;
        id = setInterval(() => {
          if (synth.getVoices().length !== 0) {
            resolve(synth.getVoices());
            clearInterval(id);
          }
        }, 10);
      }
    )
  },
  ttsSpeak(payload) {
    return new Promise((resolve, reject) => {
      this.text = payload.text;
      let selectedVoice = payload.voice;
      if(this.text != undefined && this.text.trim() != '') {
        this.ttsLoadVoices().then(voices => {
          
          let voices_in_lang = voices.filter(voice => voice.lang == `${selectedVoice.lang.slice(0,2)}-${selectedVoice.lang.slice(3,5)}` || voice.lang == `${selectedVoice.lang.slice(0,2)}_${selectedVoice.lang.slice(3,5)}`);
          let voice_by_name = voices.find(voice => voice.name == selectedVoice.name);
          let voices_available = voices.filter(voice => voice.lang.slice(0,2) == selectedVoice.lang.slice(0,2));
          let voice_to_use = null;
          if(voice_by_name) {
            voice_to_use = voice_by_name;
          } else if(voices_in_lang.length > 0) {
            voice_to_use = voices_in_lang[0];
          } else {
            voice_to_use = voices_available[0];
          }

          if(!voice_to_use) {
            reject('Your browser is not supporting this language');
            return;
          }

          var utter = new SpeechSynthesisUtterance();
          utter.rate = 0.9;
          utter.pitch = 1;
          utter.lang = selectedVoice.lang;
          utter.voice = voice_to_use;
          utter.onerror = err => {
            console.log(`speechSynthesis error: ${err.error}`);
            resolve();
          }

          if(this.text.length <= 180) {

            this.playing = true;
            this.playingType = 'bot';
            utter.text = this.text;
            utter.onend = () => {
              this.playing = false;
              resolve();
            }
            window.speechSynthesis.speak(utter);

          } else {
            let array = this.text.split('.');
            array.forEach((element, index) => {
              array[index] = element.trim();
              if(element[element.length - 1] != '.' && element != '') {
                array[index] += '.';
              }
              if(element.trim() == '') {
                array.splice(index, 1);
              }
            });
            array.forEach((element, index) => {
              if(element.length > 180) {
                let smallArray = element.split(',');
                smallArray.forEach((element, index) => {
                  smallArray[index] = element.trim();
                  if(element[element.length - 1] != '.' && element != '') {
                    smallArray[index] += ',';
                  }
                  if(element == '') {
                    smallArray.splice(index, 1);
                  }
                });
                array.splice(index, 1, ...smallArray);
              }
            });

            this.playing = true;
            this.playingType = 'bot';
            let play = (id) => {
              if(id == array.length) {
                this.playing = false;
                resolve();
              } else if(this.playing){
                utter.text = array[id];
                window.speechSynthesis.speak(utter);
                utter.onend = () => {
                  play(id + 1);
                }
              }
            }
            play(0);
          }

        })
      } else {
        reject('No text');
      }
    })
  },

  // Voice Recorder
  recorderStart() {
    return new Promise((resolve, reject) => {
      this.audioChunks = [],
      navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        this.recording = true;
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.start();
        resolve('started');
      
        this.mediaRecorder.addEventListener("dataavailable", event => {
          this.audioChunks.push(event.data);
        });
      }).catch(err => {
        reject(err.message);
      });
    })
  },
  recorderStopRecording() {
    return new Promise((resolve, reject) => {
      if(this.recording) {
        this.mediaRecorder.addEventListener("stop", () => {
          let chunk = this.audioChunks[0];
          let reader = new FileReader();
          reader.readAsDataURL(chunk); 
          reader.onloadend = function() {
            var base64data = reader.result;
            resolve({ data: base64data});          
          }
        });
        this.mediaRecorder.stop();
        this.recording = false;
      } else {
        reject('Not recording');
      }
    }) 
  },
  recorderPlay(data) {
    return new Promise((resolve, reject) => {
      if(data != undefined) {
        this.player = new Audio(data);
        this.player.addEventListener('ended', () => {
          this.playing = false;
          resolve('ended');
        })
        this.player.addEventListener('pause', () => {
          this.playing = false;
          resolve('ended');
        })
        this.playing = true;
        this.playingType = 'micro';


        this.player.play().catch(err => {
          console.log(err.message);
          this.playing = false;
          resolve('ended');
        })


      } else {
        reject('No audio to play');
      } 
    })
  },

  audioStop() {
    if(this.playingType == 'bot') {
      window.speechSynthesis.cancel();
      this.playing = false;
    } else {
      this.player.pause()
      this.playing = false;
    }
  },
}

export default audioController;